import { render, staticRenderFns } from "./question-03.vue?vue&type=template&id=088dd30a&scoped=true&lang=pug"
var script = {}
import style0 from "./question-03.vue?vue&type=style&index=0&id=088dd30a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088dd30a",
  null
  
)

export default component.exports